module.exports = __webpack_public_path__ + "static/img/event_img.b2de5fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/event_img.png
// module id = kFAq
// module chunks = 0